import { MsalService } from "@azure/msal-angular";
import { tap, concatMap, of } from "rxjs";
import { AppService } from "./app/service/app.service";

export function app_init(msalService: MsalService, appService: AppService) {
  return (): Promise<any> => {
    return new Promise((resolve, reject) => {
      msalService.handleRedirectObservable().pipe(
        tap((response) => console.log("response from handle: ", response)),
        concatMap((response) => {
          if (!response && msalService.instance.getAllAccounts().length === 0) {
            msalService.loginRedirect();
            return of(false)
          }
          return appService.get();
        }),
        tap((user: any) => {
          if (user) {
            appService.user = user;
          }
        }),
      ).toPromise().then((e) => {
        if (e) {
          resolve(true);
        }
      })
    })
  }
};
